import Vue from 'vue'
import Router from 'vue-router'
import Homepage from './views/Homepage.vue'
import Contact from './views/Contact.vue'
import Services from './views/Services.vue'
import Painting from './views/Painting.vue'
import Projects from './views/Projects.vue'
import About from './views/About.vue'
import Main from './container/Main.vue'


Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
    routes: [
      {
        path: '/',
        redirect: '/homepage',
        name: 'Main',
        component: Main,
        children: [
          {
            path: '/homepage',
            name: 'Homepage',
            component: Homepage
          },
          {
            path: '/contact',
            name: 'Contact',
            component: Contact
          },
          {
            path: '/services',
            name: 'Services',
            component: Services
          },
          {
            path: '/painting',
            name: 'Painting',
            component: Painting
          },
          {
            path: '/projects',
            name: 'Projects',
            component: Projects
          },
          {
            path: '/about',
            name: 'About',
            component: About
          },
        ]
      },
      // {
      //   path: '/login',
      //   name: 'login',
      //   component: Login
      // },
    ]
})
